document.addEventListener('DOMContentLoaded', () => {
    // Remove 'no-js' class
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    // Download component load animation
    if (!!window.IntersectionObserver) {
        let download_observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible')
                    download_observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: "0px 0px 0px 0px" });
        document.querySelectorAll('.content-download').forEach(download => { download_observer.observe(download) });
    }
});